import { assocIf } from '@btime/helpers'
import React from 'react'

import { Grid } from '../../../packages/kiti/components/structure/Grid'
import { useFormReducer } from '../../../packages/kiti/components/form/form/_reducer'
import { useSaveWidget } from './_requests/saveScreenItem'
import CanvasCard from '../../../packages/kiti/components/canvas/CanvasCard'
import LazyLoad from '../../../packages/kiti/components/helpers/LazyLoad'
import WidgetControl from './WidgetControl'
import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'
import ConditionalLink from '../../../packages/kiti/components/actions/ConditionalLink'

const Context = React.createContext({})
const { Provider } = Context
export const useWidgetState = () => React.useContext(Context)
export const useWidget = () => React.useContext(Context).widget

const WidgetWrapper = ({ children, preview, width, initialState, onClick, ...props }) => {
  const { widget } = props
  const [saveWidget] = useSaveWidget()

  const { editing } = useForm()
  const [value, actions] = useFormReducer({ ...initialState, ...widget?.data?.initialState })

  const onChangePosition = ({ size, position }) => {
    saveWidget({
      id: widget.id,
      ...assocIf(!!size, 'size', size),
      ...assocIf(!!position, 'position', position)
    })
  }

  return (
    <Provider value={{ widget, value, actions }}>
      <ConditionalLink lineHeight={1} onClick={!editing && onClick}>
        <CanvasCard
          initialSize={{ ...widget.size, width: width || widget.size.width }}
          initialPosition={widget.position}
          onChange={onChangePosition}
          preview={preview}
        >
          {!preview && <WidgetControl {...props} />}

          <Grid direction="column" justify="stretch" align="stretch" height="100%" flex={1}>
            <LazyLoad>{children}</LazyLoad>
          </Grid>
        </CanvasCard>
      </ConditionalLink>
    </Provider>
  )
}

export default WidgetWrapper
